var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-backtop',{attrs:{"target":_vm.el,"bottom":30,"right":30}},[_c('div',{staticStyle:{"{\n        height":"100%","width":"100%","background":"rgba(0, 0, 0, 0)","text-align":"center","color":"#f39518","display":"flex","font-size":"16px","flex-flow":"colum"}},[_vm._v("\n    ^ Top\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e2b9ee1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backtop/index.vue
// module id = null
// module chunks = 